import { RouterProvider, Navigate, useLocation } from 'react-router-dom';

import { UserProvider } from '@/providers';
import { QueryProvider } from '@/providers/QueryProvider';
import { createRouterWithAuth } from '@/routes';
import { useUser } from './providers/UserProvider';
import { buildLoginNavigateSearch } from '@/utils/postLoginRedirect';
import { SessionTimeoutWarning } from '@/components/SessionTimeoutWarning';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { userData, loading } = useUser();
  const location = useLocation();

  if (!userData && !loading) {
    const search = buildLoginNavigateSearch(location.pathname, location.search);
    return search ? (
      <Navigate to={{ pathname: '/login', search }} replace />
    ) : (
      <Navigate to="/login" replace />
    );
  }

  return children;
};

const App: React.FC = () => {
  const router = createRouterWithAuth(ProtectedRoute);

  return (
    <QueryProvider>
      <UserProvider>
        <SessionTimeoutWarning />
        <RouterProvider router={router} />
      </UserProvider>
    </QueryProvider>
  );
};

export default App;
